import { InjectionToken, Provider } from '@angular/core';
import { tap } from 'rxjs/operators';
import { RouterUserService } from '../api/user.service';
import { RouterUserAccountService } from '../api/useraccount.service';
import { IdentityState } from '../common/auth/identity.state';
import { INITIALIZER, Initializer } from '../initialize';
import config from './config';

export const CANNY_ID = new InjectionToken<string>('CANNY_ID');

export function cannyInitializer(
  identity: IdentityState,
  cannyId: string,
  routerUserService: RouterUserService,
  routerUserAccountService: RouterUserAccountService,
): Initializer {
  const identityListen = identity.noErrorValue.pipe(
    tap(async identity => {
      if (identity && identity.type != 'unauthorized') {
        const user = (await routerUserService
          .getUser(identity.id)
          .toPromise())!;
        const accounts = (await routerUserAccountService
          .getAccountsByUser(identity.id)
          .toPromise())!;

        const namespacedUserId =
          config.environment === 'demo'
            ? 'demo.riveteer'
            : config.environment === 'prod'
              ? identity.id.toString()
              : `${identity.id}-${config.environment}`;
        const aliasedEmail =
          config.environment === 'demo'
            ? 'demo.riveteer@rivethealth.com'
            : user.email;
        const aliasedName =
          config.environment === 'demo' ? 'Demo Riveteer' : user.name;

        Canny('identify', {
          appID: cannyId,
          user: {
            id: namespacedUserId,
            email: aliasedEmail,
            name: aliasedName,
            companies: accounts.map(account => ({
              id:
                config.environment === 'prod'
                  ? account.id
                  : `${account.id}-${config.environment}`,
              name: account.name,
            })),
          },
        });
      }
    }),
  );
  return identityListen;
}

export const CANNY_PROVIDERS: Provider[] = [
  {
    deps: [
      IdentityState,
      CANNY_ID,
      RouterUserService,
      RouterUserAccountService,
    ],
    multi: true,
    provide: INITIALIZER,
    useFactory: cannyInitializer,
  },
];
